import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {OnAccountChanged, OnLoggedOut} from "core/redux/auth/AuthReduxActions";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {Alert, AlertsReduxState} from "core/redux/alerts/AlertsReduxState";
import {PositionDirection} from "platform/protocol/enum/PositionDirection";
import AlertType from "enum/AlertType";
import AlertsEngine from "core/engine/AlertsEngine";
import {
    AddAlert,
    AddAlertPayload,
    SetAlerts,
    SetAlertsPayload, SetAlertToEdit, SetAlertToEditPayload,
    SetNewAlertType,
} from "core/redux/alerts/AlertsReduxActions";
import AlertPriceType from "enum/AlertPriceType";
import {TSMap} from "typescript-map";
import Utils from "platform/util/Utils";

const initialState = (): AlertsReduxState => {
    const alerts: TSMap<number, Alert[]> = new TSMap<number, Alert[]>();
    alerts.set(1, [
        {
            id: 1,
            type: AlertType.Price,
            priceType: AlertPriceType.Daily,
            direction: PositionDirection.Buy,
            amount: 150,
            notifyByEmail: true,
            notifyByPushNotification: false
        },
        {
            id: 2,
            type: AlertType.Change,
            priceType: AlertPriceType.Daily,
            direction: PositionDirection.Buy,
            amount: 15,
            recurring: true,
            notifyByEmail: true,
            notifyByPushNotification: true
        }
    ]);
    return {
        alerts
    };
};

export default class AlertsReducer extends Reducer<AlertsReduxState> {

    private static _instance: AlertsReducer;

    public static instance(): AlertsReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const alertsEngine: AlertsEngine = Platform.engine(ServiceType.Alerts);
        this._middlewareActions.set(SetNewAlertType, alertsEngine.doSetNewAlert);
    }

    public get name(): string {
        return "alerts";
    }

    protected setup(builder: ReducerBuilder<AlertsReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: AlertsReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(OnAccountChanged, (state: AlertsReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(SetAlerts, (state: AlertsReduxState, {payload}: Action<SetAlertsPayload>) => {
                return Object.assign({}, state, {
                    alerts: payload.alerts
                });
            })
            .handle(AddAlert, (state: AlertsReduxState, {payload}: Action<AddAlertPayload>) => {
                const {symbolId, alert} = payload;
                const newState: AlertsReduxState = Utils.merge({}, state);
                const alerts: Alert[] = newState.alerts.get(symbolId) || [];
                alerts.push(alert);
                newState.alerts.set(symbolId, alerts);
                return newState;
            })
            .handle(SetAlertToEdit, (state: AlertsReduxState, {payload}: Action<SetAlertToEditPayload>) => {
                return Object.assign({}, state, {
                    alertToEdit: payload.alert
                });
            });
    }
}
